import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { api } from "@/lib/api";
import { CreditCard } from "lucide-react";

export default function AdminPayments() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/payments").then((r) => setItems(r.data || [])); }, []);

  const revenue = items.filter((p) => p.status === "success").reduce((a, p) => a + (p.amount || 0), 0);

  return (
    <DashboardLayout>
      <h1 className="heading text-2xl font-bold">Payments</h1>
      <p className="text-sm text-slate-500 mt-1">Total revenue: <b className="text-brand">₹{revenue.toLocaleString()}</b></p>
      <div className="mt-6 rounded-xl border border-slate-200 bg-white overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left">
            <tr>
              <th className="p-3 font-semibold">TxnID</th>
              <th className="p-3 font-semibold">Amount</th>
              <th className="p-3 font-semibold">PayU ID</th>
              <th className="p-3 font-semibold">Method</th>
              <th className="p-3 font-semibold">Status</th>
              <th className="p-3 font-semibold">Date</th>
            </tr>
          </thead>
          <tbody>
            {items.map((p) => (
              <tr key={p.id} className="border-t border-slate-100">
                <td className="p-3 font-mono text-xs">{p.txnid}</td>
                <td className="p-3 font-bold">₹{p.amount}</td>
                <td className="p-3 text-slate-500 text-xs">{p.payu_id || "—"}</td>
                <td className="p-3 text-slate-500">{p.payment_method || "—"}</td>
                <td className="p-3">
                  <span className={`text-[10px] font-bold uppercase px-2 py-1 rounded ${
                    p.status === "success" ? "bg-emerald-100 text-emerald-700" :
                    p.status === "failed" ? "bg-red-100 text-red-700" :
                    "bg-amber-100 text-amber-700"
                  }`}>{p.status}</span>
                </td>
                <td className="p-3 text-slate-500 text-xs">{new Date(p.created_at).toLocaleString()}</td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr><td colSpan={6} className="p-14 text-center text-slate-500">
                <CreditCard size={36} className="mx-auto text-slate-300" />
                <div className="mt-3">No payments yet.</div>
              </td></tr>
            )}
          </tbody>
        </table>
      </div>
    </DashboardLayout>
  );
}
